import { get, post } from '../../utils/axios'

export const listIncomeDiligenceAPI = async (body) => {
  return await get('income/diligence', body)
}
export const detailIncomeDiligenceAPI = async (body) => {
  return await get('income/diligence/detail', body)
}
export const importIncomeDiligenceAPI = async (body) => {
  return await post('income/diligence/import', body)
}

export const deleteIncomeDiligenceAPI = async (body) => {
  return await post('income/diligence/delete', body)
}
